import {
  GET_LEGALSITEPLAN,
  GET_LEGALSITEPLAN_SUCCESS,
  GET_LEGALSITEPLAN_FAIL,
  DELETE_LEGALSITEPLAN,
  DELETE_LEGALSITEPLAN_SUCCESS,
  DELETE_LEGALSITEPLAN_FAIL,
  UPDATE_LEGALSITEPLAN,
  UPDATE_LEGALSITEPLAN_SUCCESS,
  UPDATE_LEGALSITEPLAN_FAIL,
  ADD_NEW_LEGALSITEPLAN,
  ADD_LEGALSITEPLAN_SUCCESS,
  ADD_LEGALSITEPLAN_FAIL,
  LEGALSITEPLAN_LOADING,
  LEGALSITEPLAN_RESET
} from "./actionType";

export const resetLegalSiteplanState = (actionType) => ({
  type: LEGALSITEPLAN_RESET,
  payload: { actionType },
});

export const getLegalSiteplanSuccess = (actionType, data) => ({
  type: GET_LEGALSITEPLAN_SUCCESS,
  payload: { actionType, data },
});

export const getLegalSiteplanFail = (actionType, error) => ({
  type: GET_LEGALSITEPLAN_FAIL,
  payload: { actionType, error },
});

export const getLegalSiteplan = data => ({
  type: GET_LEGALSITEPLAN,
  payload: data,
});

export const getLegalSiteplanLoading = () => ({
  type: LEGALSITEPLAN_LOADING
});

export const deleteLegalSiteplan = data => ({
  type: DELETE_LEGALSITEPLAN,
  payload: data,
});

export const deleteLegalSiteplanSuccess = data => ({
  type: DELETE_LEGALSITEPLAN_SUCCESS,
  payload: data,
});

export const deleteLegalSiteplanFail = error => ({
  type: DELETE_LEGALSITEPLAN_FAIL,
  payload: error,
});

export const updateLegalSiteplan = data => ({
  type: UPDATE_LEGALSITEPLAN,
  payload: data,
});

export const updateLegalSiteplanFail = error => ({
  type: UPDATE_LEGALSITEPLAN_FAIL,
  payload: error,
});

export const updateLegalSiteplanSuccess = data => ({
  type: UPDATE_LEGALSITEPLAN_SUCCESS,
  payload: data,
});

export const addNewLegalSiteplan = data => ({
  type: ADD_NEW_LEGALSITEPLAN,
  payload: data,
});

export const addLegalSiteplanSuccess = data => ({
  type: ADD_LEGALSITEPLAN_SUCCESS,
  payload: data,
});

export const addLegalSiteplanFail = error => ({
  type: ADD_LEGALSITEPLAN_FAIL,
  payload: error,
});